import React from "react";
import { Statistic, Tag } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { getFormattedAmount, getFormattedPercentage } from "Shared/Utils";
import { Tokens } from "Shared/Tokens";

const ChangeView = (props) => {
    const {
        title = "",
        previousValue = "",
        latestValue = "",
        isReverseSentiment = false,
        isSell = false,
        currencySymbol = "",
    } = props;

    const prevNum = Number(previousValue) || 0;
    const latestNum = Number(latestValue) || 0;
    const isPositive = latestNum >= prevNum;
    const isGood = isReverseSentiment ? !isPositive : isPositive;
    const percentageChange =
        prevNum !== 0 ? ((latestNum - prevNum) / prevNum) * 100 : 0;
    const toneColor = isGood ? Tokens.positive : Tokens.negative;
    const displayNumeric = isSell ? latestNum - prevNum : latestNum;

    return (
        <div>
            <Statistic
                title={title}
                value={`${currencySymbol}${getFormattedAmount(displayNumeric)}`}
                prefix={
                    isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />
                }
                suffix={
                    <Tag
                        style={{
                            backgroundColor: isGood
                                ? Tokens.positiveBg
                                : Tokens.negativeBg,
                            color: toneColor,
                            border: `1px solid ${
                                isGood
                                    ? Tokens.positiveBorder
                                    : Tokens.negativeBorder
                            }`,
                            borderRadius: Tokens.radiusTag,
                            fontVariantNumeric: "tabular-nums",
                            fontSize: "12px",
                            fontWeight: 500,
                        }}
                    >
                        {getFormattedPercentage(percentageChange)}
                    </Tag>
                }
                valueStyle={{
                    color: toneColor,
                    fontVariantNumeric: "tabular-nums",
                }}
            />
        </div>
    );
};

export default ChangeView;
